import service from '@/utils/server.js'
import API from '@/utils/API.js'

let request = function (Data, isreturnMsg) { // Data为一个对象{url: xxx, method: xxx, data: xxx}  
  let that = this
  let method = Data.method ? Data.method : 'get'
  let data = Data.data ? Data.data : {}
  let url = API[Data.url]
  let obj = {
    url: url,
    method: method,
    data: method !== 'get' ? data : '',
    params: method === 'get' ? data : ''
  }
  return new Promise((resolve, reject) => {
    service.request(obj).then(res => {
      console.log('request返回值', res)
      if (res.data.code === 0) {
        resolve(res.data)  
      } else {
        if (isreturnMsg) {
          reject(res.data)
        }else{
          resolve(res)
        }
        
      }
      
    }).catch(err => {
      console.log('-----request请求出错了-------')
      // reject(err)
    })
  })
}

export default request


